<template>
  <div class="profile-wrapper" v-if="dataDone">
    <div class="profile-main">
      <div class="profile-item">
        <div class="type">个人头像</div>
        <div class="content">
          <div class="avatar"><img :src="docProfile.avatar" alt=""></div>
        </div>
      </div>
      <div class="profile-item">
        <div class="type">真实姓名</div>
        <div class="content">{{docProfile.username}}</div>
      </div>
      <div class="profile-item">
        <div class="type">性别</div>
        <div class="content">{{docProfile.gender | genderFilter}}</div>
      </div>
      <div class="profile-item">
        <div class="type">手机号</div>
        <div class="content">{{docProfile.mobile}}</div>
      </div>
      <div class="profile-item">
        <div class="type">所在地</div>
        <div class="content">{{docProfile.province}} {{docProfile.city}}</div>
      </div>
      <div class="profile-item">
        <div class="type">执业医疗机构</div>
        <div class="content">{{docProfile.work_unit}}</div>
      </div>
      <div class="profile-item">
        <div class="type">科室</div>
        <div class="content">{{docProfile.p_dep}} - {{docProfile.dep}}</div>
      </div>
      <div class="profile-item">
        <div class="type">职称</div>
        <div class="content">{{docProfile.title | jobTitleFilter}}</div>
      </div>
      <div class="content-profile">
        <div class="content-item">
          <div class="type">执业经历</div>
          <div class="content-text">{{docProfile.description}}</div>
        </div>
        <div class="content-item" v-if="docProfile.adept">
          <div class="type">专业擅长</div>
          <div class="content-text">{{docProfile.adept}}</div>
        </div>
      </div>
    </div>
    <div class="contact-change">如需修改个人资料，请<a :href="`tel:${serviceNumber}`">联系喜乐医生客服</a></div>
  </div>
</template>

<style lang="less" scoped>
  .profile-wrapper{
    min-height: 100vh;
    background: #F7F7F7;
    padding-top: 12px;
    .profile-main{
      padding: 24px 20px 0;
      background: #FFF;
      .profile-item{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 40px;
        .type{
          font-size: 16px;
          line-height: 16px;
          color: #666;
          font-weight: bold;
        }
        .content{
          font-size: 16px;
          line-height: 16px;
          color: #999;
          .avatar{
            width: 64px;
            height: 64px;
            overflow: hidden;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            img{
              width: 100%;
            }
          }
        }
      }
      .content-profile{
        border-top: 1px solid #EEE;
        padding-bottom: 36px;
        .content-item{
          margin-top: 24px;
          .type{
            font-size: 16px;
            line-height: 16px;
            color: #666;
            font-weight: bold;
          }
          .content-text{
            margin-top: 8px;
            font-size: 14px;
            line-height: 22px;
            color: #999;
            word-break: break-all;
          }
        }
      }
    }
    .contact-change{
      padding: 24px 0 32px;
      text-align: center;
      font-size: 14px;
      line-height: 14px;
      color: #999;
      a{
        color: @xile;
        text-decoration: underline;
      }
    }
  }
</style>

<script type="text/javascript">
  export default {
    data() {
      return {
        dataDone: false,
        docProfile: {}
      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      },
      serviceNumber() {
        return this.$store.state.servicePhone;
      }
    },
    created() {
      this.$root.post('/getDoctorInfo', {
        user_id: this.userInfo.user_id,
        type: 1
      }).then(data => {
        this.dataDone = true;
        this.docProfile = data;
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Doctor/Mine/profile.vue